const collectionReadMore = document.querySelector('.read-more');
const collectionDescContainer = document.getElementById('coll-header-desc-container');

if (collectionReadMore != null) {
    collectionReadMore.addEventListener('click', function() {
        collectionDescContainer.classList.toggle('expand')
    
        if (collectionReadMore.innerText === 'Read more') {
            collectionReadMore.innerText = 'Read less';
        } else {
            collectionReadMore.innerText = 'Read more';
        }
    });
}
